module.exports = __webpack_public_path__ + "static/img/hall01.ad086a5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sub/02/hall01.jpg
// module id = kfKG
// module chunks = 1